import React, { useState } from "react";
import { ShieldCheck } from "@phosphor-icons/react";
import { Button } from "../../components/ui/button";
import ChangePasswordDialog from "../../components/ChangePasswordDialog";
import SettingsSection from "./SettingsSection";

export default function SecurityPanel() {
  const [pwOpen, setPwOpen] = useState(false);
  return (
    <SettingsSection title="Security" description="Manage how you sign in to your account.">
      <div className="surface-card p-4 flex items-start gap-3" data-testid="security-card">
        <div className="w-9 h-9 rounded-md bg-blue-50 text-blue-600 flex items-center justify-center shrink-0"><ShieldCheck size={18} /></div>
        <div className="flex-1 min-w-0">
          <div className="font-medium text-slate-800">Password</div>
          <div className="text-xs text-slate-500 mt-0.5">Change the password you use to sign in.</div>
        </div>
        <Button type="button" size="sm" variant="outline" onClick={() => setPwOpen(true)} data-testid="open-change-password">
          Change password
        </Button>
      </div>
      <ChangePasswordDialog open={pwOpen} onOpenChange={setPwOpen} />
    </SettingsSection>
  );
}
